import classNames from 'classnames';
import {
  HTMLAttributes,
  PropsWithChildren,
  TableHTMLAttributes,
  TdHTMLAttributes,
  ThHTMLAttributes,
} from 'react';

interface CellProps extends PropsWithChildren {
  className?: string;
}

interface TableProps extends CellProps, TableHTMLAttributes<HTMLTableElement> {}
interface THProps extends CellProps, ThHTMLAttributes<HTMLTableCellElement> {}
interface TDProps extends CellProps, TdHTMLAttributes<HTMLTableCellElement> {}
interface TRProps extends CellProps, HTMLAttributes<HTMLTableRowElement> {}

const Th = ({ className, children, ...rest }: THProps) => (
  <th
    className={classNames(
      'text-heading bg-white py-3 pr-3 pl-2 font-semibold',
      'border-t-1 border-b-2 border-neutral-800',
      // 'border-r border-b-2 border-neutral-300 last:border-r-0',
      className
    )}
    {...rest}
  >
    {children}
  </th>
);

const Td = ({ className, children, ...rest }: TDProps) => (
  <td className={classNames('px-2 py-2 text-neutral-800', className)} {...rest}>
    {children}
  </td>
);

const Tr = ({ className, children, ...rest }: TRProps) => (
  <tr
    className={classNames(
      'border-b border-neutral-200 odd:bg-neutral-50',

      className
    )}
    {...rest}
  >
    {children}
  </tr>
);

const Table = ({ className, children, ...rest }: TableProps) => (
  <table className={classNames('text-md', className)} {...rest}>
    {children}
  </table>
);

Table.Td = Td;
Table.Th = Th;
Table.Tr = Tr;

export default Table;
